import { render, staticRenderFns } from "./operationPromotionStorePromotionAdd.vue?vue&type=template&id=87442be0&scoped=true"
import script from "./operationPromotionStorePromotionAdd.vue?vue&type=script&lang=js"
export * from "./operationPromotionStorePromotionAdd.vue?vue&type=script&lang=js"
import style0 from "./operationPromotionStorePromotionAdd.vue?vue&type=style&index=0&id=87442be0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87442be0",
  null
  
)

export default component.exports